import { phone } from "phone";

const validateData = (data: string, validationType: string, country = "US") => {
  const regPhone = /^\+?\d{5,17}$/g;
  const regEmail =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const regUsername = /^[a-zA-Z0-9._!@#$%^&*-]{3,}/g; //3-30 characters limit
  const regName = /^[A-Za-z\s]{2,40}$/; //accept only a-z,A-Z not any special characters either start(^) or end($)
  const regPassword =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*-])(?=.{6,})/g;
  const regCompany = /^(\w+\s?)*\w*$/;
  // const regCompany = /^[\w]{3,75}$/;
  const regTimer = /^[0-9]+$/g;
  const regCharacters = /[a-zA-Z0-9\s!@#$%^&*()[_\-~`=+'\[\]";:\|?,<.>" "]/gi;
  const regWords = /\S+/g;
  const regUrlParam = /^[-a-zA-Z0-9@:%._+~#=]{1,2048}$/; //accept only a-z,A-Z and numbers not any special characters either start(^) or end($)
  const regUrl =
    /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,30}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/;

  switch (validationType) {
    case "name":
      data = data.trim().replace(/\s\s/g, " ");
      if (regName.test(data)) return true;
      break;
    case "email":
      if (regEmail.test(data.toLowerCase())) return true;
      break;
    case "password":
      if (regPassword.test(data)) return true;
      break;
    case "username":
      if (regUsername.test(data)) return true;
      break;
    case "company":
      if (regCompany.test(data)) return true;
      break;
    case "phone":
      if (regPhone.test(data.replace(/ /g, ""))) return true;
      // if (phone(data, { country }).isValid) return true  ;
      break;
    case "address":
      if (data !== "") return true;
      break;
    case "timer":
      if (regTimer.test(data)) return true;
      break;
    case "urlParam":
      if (regUrlParam.test(data)) return true;
      break;
    case "url":
      if (regUrl.test(data)) return true;
      break;
  }
  return false;
};
export default validateData;
